import styled from 'styled-components';
import { Screen, screenBiggerThan } from '@client/styles/styled-components/breakpoints';

export const USPSliderWrapper = styled.div`
    width: 100%;
    .slider {
        height: 32px;
        overflow: hidden;
        background: #ffc0ff;
    }
`;

export const USPCardWrapper = styled.div<{ slideAmt: number }>`
    position: relative;
    top: ${props => props.slideAmt}px;
    left: 0;
    transition: 0.5s;
    transition-delay: 0.3s;
    ${screenBiggerThan(Screen.smallTablet)} {
        display: flex;
        justify-content: center;
        .mobile-extra {
            display: none;
        }
    }
`;

export const USPCard = styled.div`
    display: flex;
    align-items: center;
    height: 32px;
    justify-content: center;
    svg {
        fill: #1a1a1a;
        height: 20px;
    }
    span {
        font-family: 'Helvetica Now Text', sans-serif;
        font-weight: 500;
        font-size: 14px;
        margin: 0 22px;
        text-transform: uppercase;
        color: #1a1a1a;
    }
`;
